import React from 'react'
import { observer } from 'mobx-react'
import { observable, makeObservable } from 'mobx';
import ApiClient from '../../api/ApiClient'
import { CircularProgress } from '@mui/material'
import { formatCurrency } from '../../common/Util'
import moment from 'moment'
import {
  PaymentConfirmationGroup, PaymentConfirmationLabel,
  PaymentConfirmationMessage,
  PaymentConfirmationStatusMessage, PaymentConfirmationValue
} from "../../styles/Payment.styles";

type Props = {
  url: string
}

const DConfirmation = observer(class DConfirmation extends React.Component<Props> {
  private confirmationData?: ConfirmationData;
  private loading = false;
  private error: string;

  constructor(props: Props) {
    super(props);

    makeObservable<DConfirmation, "confirmationData" | "loading" | "error">(this, {
      confirmationData: observable,
      loading: observable,
      error: observable
    });
  }

  componentDidMount (): void {
    if (!this.confirmationData) {
      this.loadConfirmationData()
    }
  }

  private loadConfirmationData = () => {
    this.loading = true

    ApiClient.getInstance().get(this.props.url)
      .then(response => {
        this.confirmationData = response.data
      })
      .catch(error => this.error = 'There was an error loading the payment method data')
      .then(() => this.loading = false)
  }

  private renderConfirmation = (confirmationData: ConfirmationData) => {
    return <div>
      <PaymentConfirmationStatusMessage>{confirmationData.statusMessage}</PaymentConfirmationStatusMessage>
      <PaymentConfirmationMessage>{confirmationData.confirmation.message}</PaymentConfirmationMessage>
      <PaymentConfirmationGroup>
        <PaymentConfirmationLabel>
          {confirmationData.amountLabel}
        </PaymentConfirmationLabel>
        <PaymentConfirmationValue>
          {formatCurrency(confirmationData.amount)}
        </PaymentConfirmationValue>
      </PaymentConfirmationGroup>
      <PaymentConfirmationGroup>
        <PaymentConfirmationLabel>
          {confirmationData.dateLabel}
        </PaymentConfirmationLabel>
        <PaymentConfirmationValue>
          {moment(confirmationData.date, 'YYYY-MM-DDTHH:mm:ss').format('MM/DD/YYYY')}
        </PaymentConfirmationValue>
      </PaymentConfirmationGroup>
      <PaymentConfirmationGroup>
        <PaymentConfirmationLabel>
          Payment Account:

        </PaymentConfirmationLabel>
        <PaymentConfirmationValue>
          {confirmationData.accountLabel}
        </PaymentConfirmationValue>
      </PaymentConfirmationGroup>
      <PaymentConfirmationGroup>
        <PaymentConfirmationLabel>
          {confirmationData.confirmationLabel}
        </PaymentConfirmationLabel>
        <PaymentConfirmationValue>
          {confirmationData.confirmationCode}
        </PaymentConfirmationValue>
      </PaymentConfirmationGroup>
    </div>
  }

  render () {
    return this.error
      ? <div>{this.error}</div>
      : (this.loading || !this.confirmationData)
        ? <CircularProgress/>
        : this.renderConfirmation(this.confirmationData)
  }
});

type ConfirmationData = {
  id: number
  method: {
    id: number
    method: string
    methodDetail: {
      accountType: string
      accountNo: string
      accountAddl1: string
    }
  }
  status: string
  statusMessage: string
  confirmation: {
    status: string
    code: string
    email: string
    sms: string
    message: string
  }
  amountLabel: string
  amount: number
  dateLabel: string
  date: string
  dateLocale: string
  accountLabel: string
  confirmationLabel: string
  confirmationCode: string
}

export default DConfirmation
